import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues } from '../sbSharedRefineMenuHelpers';

// components
import { SbSharedRefineMenuCaratWeightRange } from './SbSharedRefineMenuCaratWeightRange';
import { SbSharedRefineMenuRadioSelectList } from '../SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelectList';

// styles
import styles from './SbSharedRefineMenuCaratWeight.scss';

function SbSharedRefineMenuCaratWeightComponent(props) {
    const { filterName, filter, searchBrowse, applyOnBlur } = props;
    const { appliedFilters } = searchBrowse;

    const appliedFilterValues = getFilterValues(appliedFilters, filterName);

    // The preset multi-select carat buckets are all the other items in "values" array.
    const presetValues = get(filter, 'values').slice(1);

    return (
        <div className={styles.container}>
            <SbSharedRefineMenuCaratWeightRange
                filter={filter}
                applyOnBlur={applyOnBlur}
                values={appliedFilterValues}
            />
            <SbSharedRefineMenuRadioSelectList
                values={presetValues}
                filterName={filterName}
                searchBrowse={searchBrowse}
                notDismissable={false}
                collapsedItemCount={0}
            />
        </div>
    );
}

SbSharedRefineMenuCaratWeightComponent.propTypes = {
    filter: PropTypes.object,
    applyOnBlur: PropTypes.bool,
    searchBrowse: PropTypes.shape({
        appliedFilters: PropTypes.array,
    }),
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
};

export const SbSharedRefineMenuCaratWeight = createFragmentContainer(
    SbSharedRefineMenuCaratWeightComponent,
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuCaratWeight_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuRadioSelectList_searchBrowse
                appliedFilters {
                    name
                    values {
                        urlLabel
                        displayName
                    }
                }
            }
        `,
    }
);
